module.exports = __webpack_public_path__ + "static/media/soviet_naval_artillery_120x120.f7bc2774.png";